export const RepairOrderOpening = "Repair Order Opening";
export const NewLabel = "New";
export const RepairOrderLabel ="Repair Order"
export const NEW_REPAIR_ORDER_LABEL = "New Repair Order"
export const EDIT_REPAIR_ORDER_LABEL = "Edit Repair Order"
export const CUSTOMER_COMPLAINTS_LABEL="Customer Complaints"
export const QUOTAION_NO_LABEL="Quotation No"
export const WORK_ORDER_NO_LABEL="Work Order No"
export const CHASSIS_NO_LABEL = "Chassis No"
export const ENGINE_NO_LABEL = "Engine No"
export const GEAR_BOX_NO_LABEL = "Gear Box No"
export const VDN_NO_LABEL = "VDN No"
export const REGIATRTION_NO_LABEL = "Registration No"
export const ENGINE_HOUR_LABEL = "Engine Hour"
export const REPAIR_ORDER_TYPE_LABEL = "Repair Order Type"
export const KM_LABEL = "KM"
export const SITE_LOCATION_LABEL = "Site Location"
export const TECHNICIAN_LABEL = "Technician Name"
export const CUSTOMER_ID_LABEL = "Customer ID"
export const CUSTOMER_NAME_LABEL = "Customer Name"
export const START_DATE_LABEL = "Start Date"
export const REPAIR_PARTS_ORDER_LABEL = "Repair/Parts Order"

export const FilterByList = [
    { label: "Customer", value: "Customer" },
    { label: "Technician", value: "Technician" },
    { label: "Date", value: "Date" },
    { label: "Location", value: "Location" },
  ];

  export const RepairOrderTypeList = [
    { label: "New work", value: "New work" },
    { label: "Accident", value: "Accident" },
    { label: "Warranty", value: "Warranty" },
    { label: "Other", value: "Other" },
  ];
